export default __webpack_public_path__ + "static/verlauf-b95c462b2f194c577196e2cf773da6f9.jpg";